module.exports = __webpack_public_path__ + "img/960.f456bfcf.svg";